module.exports = __webpack_public_path__ + "static/media/news_event.4fad1b06.png";